import styled, { css } from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";

export const StyledInput = styled.input<{ isInvalid?: boolean; disabled: boolean }>`
    ${setFontVariant("input2")}
    font-size: 14px !important;
    background-color: ${({ disabled }) => (disabled ? colorsPalettes.bluegrey["200"] : colorsPalettes.carbon["0"])};
    transition:
        background-color 0.25s,
        color 0.25s,
        box-shadow 0.25s;
    border: solid 1px ${({ isInvalid }) => (isInvalid ? colorsPalettes.red[400] : colorsPalettes.midnight[50])};
    border-radius: 3px !important;
    height: 40px;
    position: relative;

    align-items: center;
    width: 100%;
    text-align: left;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "unset")};
    margin: 0;
    padding: 0 16px !important;

    &::placeholder {
        color: ${colorsPalettes.carbon[200]};
    }

    &:focus {
        outline: none;
        box-shadow: 0 3px 5px 0 ${rgba(colorsPalettes.carbon[500], 0.12)};
        border: 1px solid ${colorsPalettes.midnight[50]};
    }

    ${({ disabled }) =>
        disabled &&
        css`
            background-color: ${colorsPalettes.bluegrey[200]} !important;
            color: ${colorsPalettes.midnight[100]} !important;
            cursor: default !important;
        `}
`;
